import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD, SIZE_FIELD } from "../commonFields";

export const ExpandableBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Expandable Block",
  inputs: [
    {
      name: "isOpen",
      type: "boolean",
      helperText: "Set to true to open the block when page is initially loaded",
      localized: false,
    },
    {
      name: "showDivider",
      type: "boolean",
      defaultValue: true,
      localized: false,
    },
    {
      name: "button",
      type: "object",
      subFields: [
        {
          name: "viewMore",
          type: "string",
          required: false,
          localized: true,
        },
        {
          name: "viewLess",
          type: "string",
          required: false,
          localized: true,
        },
        DLD_FIELD,
        DLT_FIELD,
        SIZE_FIELD,
        {
          name: "automationId",
          type: "string",
          friendlyName: "Automation ID",
          defaultValue: "expandable-block-button",
          localized: false,
          required: true,
        },
      ],
    },
  ],
  defaultStyles: {
    width: "100%",
  },
  canHaveChildren: true,
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Box",
      },
      children: [
        {
          "@type": "@builder.io/sdk:Element",
          component: {
            name: "Text",
            options: {
              text: "Lorem ipsum ...",
            },
          },
        },
      ],
    },
  ],
};
